import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="ftr">
      {/* Wave decoration */}
      <div className="ftr__wave">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path d="M0,60 C360,120 720,0 1080,60 C1260,90 1380,40 1440,60 L1440,120 L0,120 Z" />
        </svg>
      </div>

      <div className="ftr__main">
        <div className="ftr__container">
          <div className="ftr__grid">
            {/* Brand column */}
            <div className="ftr__brand">
              <Link to="/" className="ftr__logo-link">
                <img
                  src="/assets/images/foot.png"
                  alt="Bouchaddakh"
                  className="ftr__logo"
                />
              </Link>
              <p className="ftr__desc">
                Votre partenaire de confiance pour les équipements industriels en Tunisie depuis plus de 40 ans.
              </p>
            </div>

            {/* Navigation column */}
            <div className="ftr__col">
              <h4 className="ftr__heading">Navigation</h4>
              <ul className="ftr__links">
                <li><Link to="/">Accueil</Link></li>
                <li><Link to="/produits">Nos Produits</Link></li>
                <li><Link to="/about">Qui sommes-nous</Link></li>
                <li><Link to="/contact">Contactez-nous</Link></li>
              </ul>
            </div>

            {/* Products column */}
            <div className="ftr__col">
              <h4 className="ftr__heading">Nos Produits</h4>
              <ul className="ftr__links">
                <li><Link to="/incendie">Incendie</Link></li>
                <li><Link to="/petroliers">Pétroliers</Link></li>
                <li><Link to="/robinetterie">Robinetterie</Link></li>
                <li><Link to="/lavage">Lavage</Link></li>
                <li><Link to="/hydraulique">Hydraulique</Link></li>
                <li><Link to="/tuyauterie">Tuyauterie</Link></li>
              </ul>
            </div>

            {/* Contact column */}
            <div className="ftr__col">
              <h4 className="ftr__heading">Contact</h4>
              <ul className="ftr__contact">
                <li>
                  <i className="fa-solid fa-location-dot"></i>
                  <span>29 Bis, rue Oum Kalthoum,<br />1001 Tunis, Tunisie</span>
                </li>
                <li>
                  <i className="fa-solid fa-phone"></i>
                  <a href="tel:+21671330366">+(216) 71 330 366</a>
                </li>
                <li>
                  <i className="fa-solid fa-fax"></i>
                  <a href="tel:+21671333451">+(216) 71 333 451</a>
                </li>
                <li>
                  <i className="fa-solid fa-envelope"></i>
                  <a href="mailto:ste@bouchaddakh.com">ste@bouchaddakh.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="ftr__bottom">
        <div className="ftr__container">
          <div className="ftr__bottom-inner">
            <p className="ftr__copy">
              &copy; {new Date().getFullYear()} BOUCHADDAKH. Tous droits réservés.
            </p>
            <p className="ftr__credit">
              Design by{" "}
              <a href="https://bouchaddakh.com/" target="_blank" rel="noreferrer">
                IEB
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Scroll to top */}
      <button
        className={`ftr__top-btn ${showTop ? "ftr__top-btn--visible" : ""}`}
        onClick={scrollToTop}
        aria-label="Retour en haut"
      >
        <i className="fa-solid fa-chevron-up"></i>
      </button>
    </footer>
  );
}

export default Footer;
